import React from "react";

const Banner = () => (
  <div className="row banner">
    <div className="banner-text">
      <h1 className="responsive-headline">Downtown Health Centre</h1>
    </div>
  </div>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js